import type { FC } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faClose } from '@fortawesome/pro-regular-svg-icons/faClose'

type CloseButtonProps = {
  onClose: (event: Record<string, never>, reason: 'backdropClick' | 'escapeKeyDown') => void
}

const CloseButton: FC<CloseButtonProps> = ({ onClose }) => (
  <div className="absolute top-6 right-6">
    <FontAwesomeIcon
      onClick={() => onClose({}, 'escapeKeyDown')}
      id="close-button"
      data-testid="close-button"
      icon={faClose}
      size="xl"
      role="button"
      className="text-blue-600"
    />
  </div>
)
export default CloseButton
